module.exports = __webpack_public_path__ + "assets/finance-a7dfad591c445bc1795de6d691d9c985.svg";